angular.module('impactx.sapconfig').controller('SapMatNrImportCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    'trns',
    SapMatNrImportCtrl
]);

function SapMatNrImportCtrl($scope, dataGen, ToastService, $mdDialog, TranslationService, trns) {
    var ctrl = this;
    ctrl.index = 0;

    $scope.uploadExcel = {};
    $scope.trns = trns;

    ctrl.import = function (event) {
        $scope.uploadInProgress = true;
        var paramObj = {
            file: $scope.uploadExcel.file
        };
        dataGen.uploadFile(paramObj, '/sapconfiguration/importmatnr', true).then(function (data) {
            $scope.uploadInProgress = false;
            $scope.data = data.data;
            ctrl.index = 1;
        }, function () {
            $scope.uploadInProgress = false;
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.confirm = function () {
        $mdDialog.hide();
    }

}